import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgThumbsUp = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "currentColor", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M15.03 9.684h3.965c.322 0 .64.08.925.232s.532.374.717.645a2.11 2.11 0 0 1 .242 1.883l-2.36 7.201c-.288.814-.48 1.355-1.884 1.355-2.072 0-4.276-.677-6.157-1.256-.472-.145-.924-.284-1.348-.404h-.115V9.478a25.5 25.5 0 0 0 4.238-5.514 1.8 1.8 0 0 1 .901-.83 1.74 1.74 0 0 1 1.21-.048c.396.13.736.397.96.757.225.36.32.788.269 1.211zM4.177 10H7v8a2 2 0 1 1-4 0v-6.823C3 10.527 3.527 10 4.176 10Z",
    clipRule: "evenodd"
  }
) }));

export { SvgThumbsUp as default };
//# sourceMappingURL=thumbs-up.mjs.map
